import { useEffect, useState } from 'react'

import type { Gate, Location } from '../../models/client/reports'

export const useLocationGates = (activeLocation: Location) => {
  const [gates, setGates] = useState<Gate[]>([])

  useEffect(() => {
    const activeGates = Object.values(activeLocation?.gates || {}).map((gate) => {
      return { label: gate.name, value: gate.id, siteId: gate.siteId }
    })

    const filteredGates = activeGates.filter((gate) => gate.siteId === activeLocation.value)

    setGates(filteredGates)
  }, [activeLocation])

  return gates
}
